export default "__VITE_ASSET__BLE7tXdd__"